<template>
  <button type="button" class="btn btn-primary px-3" @click="newRegister">
    Nuevo registro Manual
  </button>
</template>
<script>
import { useRouter } from "vue-router";
export default {
  props: {
    id_persona: String,
  },
  setup() {
    const router = useRouter();
    const newRegister = () => {
      router.push({
        name: "registerForm",
        params: {
          id_persona: 0,
          id_orden_judicial: 0,
        },
      });
    };
    return {
      newRegister,
    };
  },
};
</script>
